import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface UiState {
  forgotPasswordModalOpen: boolean
  resetPasswordModalOpen: boolean
  securityModalOpen: boolean
}

export const initialState: UiState = {
  forgotPasswordModalOpen: false,
  resetPasswordModalOpen: false,
  securityModalOpen: false,
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setForgotPasswordModalOpen: (state: UiState, action: PayloadAction<boolean>) => {
      state.forgotPasswordModalOpen = action.payload
    },
    setResetPasswordModalOpen: (state: UiState, action: PayloadAction<boolean>) => {
      state.resetPasswordModalOpen = action.payload
    },
    setSecurityModalOpen: (state: UiState, action: PayloadAction<boolean>) => {
      state.securityModalOpen = action.payload
    },
  },
})

export const { setForgotPasswordModalOpen, setResetPasswordModalOpen, setSecurityModalOpen } =
  uiSlice.actions

export default uiSlice.reducer
